import actions from "./actions";
import {setRequestReducer, setSuccessReducer} from "../helper";

const initState = {
    paymentMethodCreateState: false,
    paymentMethodCreateResult: {},

    paymentMethodImportState: false,
    paymentMethodReadState: false,

    paymentMethodReadAllState: false,
    paymentMethods: [],
    pagination: {},

    paymentMethodUpdateState: false,
    paymentMethodUpdateResult: {},

    paymentMethodArchiveState: false,
    paymentMethodArchiveResult: {},

    paymentMethodDeleteState: false,

    paymentMethod: false,

    paymentMethodDrawerVisible: false,
    paymentMethodDrawerMode: undefined,
};

export default function appReducer(state = initState, action = {}) {
    switch (action.type) {
        case actions.PAYMENT_METHOD_CREATE_REQUEST:
            return setRequestReducer(state, 'paymentMethodCreateState');
        case actions.PAYMENT_METHOD_CREATE_SUCCESS:
            return setSuccessReducer(state, 'paymentMethodCreateState', {
                paymentMethodCreateResult: action.paymentMethod,
            });

        case actions.PAYMENT_METHOD_READ_ALL_REQUEST:
            return setRequestReducer(state, 'paymentMethodReadAllState');
        case actions.PAYMENT_METHOD_READ_ALL_SUCCESS:
            return setSuccessReducer(state, 'paymentMethodReadAllState', {
                paymentMethods: action.paymentMethods,
                pagination: {
                    total: action.pagination.total,
                    current: action.pagination.current_page,
                    pageSize: action.pagination.per_page,
                },
            });

        case actions.PAYMENT_METHOD_READ_REQUEST:
            return setRequestReducer(state, 'paymentMethodReadState');
        case actions.PAYMENT_METHOD_READ_SUCCESS:
            return setSuccessReducer(state, 'paymentMethodReadState', {
                paymentMethod: action.paymentMethod,
            });

        case actions.PAYMENT_METHOD_UPDATE_REQUEST:
            return setRequestReducer(state, 'paymentMethodUpdateState');
        case actions.PAYMENT_METHOD_UPDATE_SUCCESS:
            return setSuccessReducer(state, 'paymentMethodUpdateState');

        case actions.PAYMENT_METHOD_ARCHIVE_REQUEST:
            return setRequestReducer(state, 'paymentMethodArchiveState');
        case actions.PAYMENT_METHOD_ARCHIVE_SUCCESS:
            return setSuccessReducer(state, 'paymentMethodArchiveState');

        case actions.PAYMENT_METHOD_DELETE_REQUEST:
            return setRequestReducer(state, 'paymentMethodDeleteState');
        case actions.PAYMENT_METHOD_DELETE_SUCCESS:
            return setSuccessReducer(state, 'paymentMethodDeleteState');

        case actions.PAYMENT_METHOD_CHANGE: { // Partial update
            const paymentMethod = {
                ...(action.reset ? initState.paymentMethod : state.paymentMethod),
                ...action.request,
            };

            return {
                ...state,
                paymentMethod,
            };
        }

        case actions.PAYMENT_METHOD_TOGGLE_DRAWER:
            console.log('action', action);
            return {
                ...state,
                paymentMethodDrawerVisible: action.visible,
                paymentMethodDrawerMode: action.mode,
            };

        case actions.PAYMENT_METHOD_RESET_STATE:
            return {
                ...initState,
            };
        default:
            return state;
    }
}
